



export function tutorial() {
  const overlay = document.createElement("div");
  overlay.id = "welcomeOverlay";
  overlay.style.position = "fixed";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.backgroundColor = "#fdf300e8";
  overlay.style.display = "flex";
  overlay.style.flexDirection = "column";
  overlay.style.alignItems = "center";
  overlay.style.justifyContent = "flex-start";
  overlay.style.zIndex = "99999";
  overlay.style.color = "white";
  overlay.style.fontSize = "20px";
  overlay.style.fontFamily = "Arial, sans-serif";
  overlay.style.textAlign = "center";
  overlay.style.padding = "20px";
  overlay.style.boxSizing = "border-box";
  overlay.style.overflowY = "auto"; // 🔹 scroll vertical

  overlay.innerHTML = `
    <div style="max-width: 600px; width: 100%; color:#333333;">
      <p style="margin-bottom: 20px;">
        ✨ <strong>Command controls </strong> <br><br>
        This is the manual for navigating between coral reefs using a mobile device. If you try it on a PC, you can use the mouse — right-click to rotate and left-click to move.✨
      </p>

    <p style="margin-top: 30px; font-size: 16px; opacity: 0.8;">
        Tap anywhere to continue
      </p>

      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 15px;">
        <img src="https://cozumel-reef-maps.com.mx/Views/Default/img/rotation.png" alt="tutorial 1" style="width: 100%; height: auto; border-radius: 10px;">
        <img src="https://cozumel-reef-maps.com.mx/Views/Default/img/translation.png" alt="tutorial 2" style="width: 100%; height: auto; border-radius: 10px;">
        <img src="https://cozumel-reef-maps.com.mx/Views/Default/img/zoom.png" alt="tutorial 3" style="width: 100%; height: auto; border-radius: 10px;">
        <img src="https://cozumel-reef-maps.com.mx/Views/Default/img/double_click.png" alt="tutorial 4" style="width: 100%; height: auto; border-radius: 10px;">
      </div>

      
    </div>
  `;

  document.body.appendChild(overlay);

  // 🔹 Quitar overlay al hacer clic
  overlay.addEventListener("click", () => {
    overlay.remove();
  });
}

